import React from 'react'

import { InAppCommsContent } from 'generated/resources/graphql'

import AnnouncementModal from './AnnouncementModal'
import Banner from './Banner'
import CustomerForm from './CustomerForm'
import SidebarCard from './SidebarCard'

export type InAppComponent = {
  id: string
  name: string
  type: string
  content: InAppCommsContent
}

interface InAppCommunicationProps {
  component: InAppComponent
  onDismiss: (componentId: string) => void
}

const InAppCommunication = ({ component, onDismiss }: InAppCommunicationProps) => {
  const handleDismiss = () => {
    onDismiss(component.id)
  }

  switch (component.type) {
    case 'banner':
      return (
        <Banner
          content={component.content.banner}
          componentName={component.name}
          onDismiss={handleDismiss}
        />
      )
    case 'modal':
      return (
        <AnnouncementModal
          content={component.content.modal}
          componentName={component.name}
          onDismiss={handleDismiss}
        />
      )
    case 'sidebar_card':
      return (
        <SidebarCard
          content={component.content.sidebarCard}
          componentName={component.name}
          onDismiss={handleDismiss}
        />
      )
    case 'form':
      return (
        <CustomerForm
          content={component.content.form}
          componentName={component.name}
          onDismiss={handleDismiss}
        />
      )
    default:
      return null
  }
}

export default InAppCommunication
